var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54793 9.84844C8.54793 9.84844 9.59396 9.2497 9.86765 9.10562C10.1407 8.96125 10.4236 8.92464 10.5954 9.02974C10.8555 9.18888 13.04 10.642 13.2239 10.7708C13.4079 10.8998 13.4964 11.268 13.2434 11.6284C12.9916 11.9892 11.8295 13.4152 11.3371 13.3999C10.844 13.3839 8.79357 13.3388 4.92711 9.47142C1.06183 5.60496 1.01607 3.55394 1.00013 3.06089C0.98448 2.56784 2.41049 1.40577 2.77097 1.15364C3.13205 0.901799 3.50081 0.996571 3.62894 1.17371C3.77449 1.37536 5.21083 3.55305 5.36908 3.80253C5.47744 3.97318 5.43758 4.25749 5.29321 4.53088C5.14972 4.80487 4.55068 5.8506 4.55068 5.8506C4.55068 5.8506 4.97287 6.57069 6.40035 7.99788C7.82813 9.42536 8.54793 9.84844 8.54793 9.84844Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact_icon.6d3bcdc5bad47422fb4ff549d6018f4c.svg";
export { ForwardRef as ReactComponent };